import styled from 'styled-components';
import { media as oldMedia } from 'legacyComponents/styled/styleUtils';
import { customMedia, media } from 'styles/utils';
import config from 'apps/project/config';

import { Link } from 'core/routing';
import { Indicator } from 'legacyComponents/styled/lib';
import { Date } from 'apps/components/date';
import { Avatar } from 'apps/components/shared';

import Paragraph from 'components/Paragraph';
import Icon from 'components/Icon';

export const ParagraphStyled = styled(Paragraph)`
  text-align: center;
`;

export const Overview = styled.section`
  margin: ${props =>
    props.atHead
      ? `${props.theme.spacing.medium} auto ${props.theme.spacing.default}`
      : `${props.theme.spacing.default} auto ${props.theme.spacing.default}`};
  ${oldMedia.xs`
    margin: ${props =>
      `${props.theme.spacing.default} auto ${props.theme.spacing.default}`};
  `};
  height: 100%;
`;

export const NameIndicator = styled(Indicator)`
  width: 60%;
  height: 27px;
  margin-bottom: ${props => props.theme.spacing.xsmall};
  display: inline-block;
`;

export const PhaseIndicator = styled(NameIndicator)`
  width: 20%;
  float: right;
`;

export const ImageIndicator = styled(Indicator)`
  width: 100%;
  height: 100%;
  margin-bottom: ${props => props.theme.spacing.default};
  /* Media queries */
  ${oldMedia.m`
    height: 493px;
  `}
  ${oldMedia.s`
    height: 393px;
  `}
  ${oldMedia.xs`
    height: 240px;
  `}
`;

export const DataIndicatorStyled = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  margin-top: ${props => props.theme.spacing.large};
  margin-left: -${props => props.theme.spacing.xlarge};
  margin-right: -${props => props.theme.spacing.xlarge};
  padding: ${props =>
    `${props.theme.spacing.large} ${props.theme.spacing.xlarge}`};
  border-top: 1px solid ${props => props.theme.color.wfGrey200};
  ${Indicator} {
    width: 50%;
  }
`;

export const Wrapper = styled.article`
  margin: 0 auto ${props => props.theme.spacing.xlarge} auto;
  display: flex;
  flex-direction: column;
  box-shadow: 0 10px 90px -20px rgba(0, 0, 0, 0.15);
  max-width: ${config.width}px;
  //overflow: hidden;

  ${customMedia.greaterThan('sxlarge')`
    width: 100%;
    max-width: initial;
    margin: 0 0 ${props => props.theme.spacing.xlarge} 0;
    flex-direction: row;
    justify-content: flex-end;
  `}
  height: 100%;
`;

export const InfoWrapper = styled.div`
  position: relative;
  padding: ${props =>
    `${props.theme.spacing.medium} ${props.theme.spacing.medium} 0`};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  ${customMedia.greaterThan('sxlarge')`
    padding: ${props =>
      `${props.theme.spacing.medium} ${props.theme.spacing.medium} 0`};
    order: -1;
    width: calc(100% - ${config.width}px);
    
  `}
  height: 100%;
`;

export const RowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: auto 0 0 0;
`;

export const ContributorRowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
`;

export const LinkContributor = styled(Link)`
  position: relative;
  z-index: 10;
  & + & {
    margin-left: -${props => props.theme.spacing.small};
    z-index: 5;
  }
`;

export const Contributor = styled(Avatar)`
  width: 44px;
  height: 44px;
  border: 1px solid ${props => props.theme.color.wfGrey200};
  /*TODO: Review margin props last and only, are they needed */
  margin-right: ${props =>
    props.last || props.only ? '0' : props.theme.spacing.xsmall};
  vertical-align: middle;
  & + & {
    margin-left: -${props => props.theme.spacing.small};
  }
  /* Media queries */
  ${media.medium`
     margin-right: ${props =>
       props.last || props.only ? '0' : props.theme.spacing.default};
  `}
`;
export const ContributorWrapper = styled.div`
  margin-right: ${props => props.theme.spacing.xsmall};
`;

export const ContributorDiff = styled.div`
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background-color: ${props => props.theme.color.wfGrey200};
  color: ${props => props.theme.color.wfGrey500};
  border: 1px solid ${props => props.theme.color.wfGrey200};
  line-height: 42px;
  text-align: center;
  cursor: pointer;
  display: inline-block;
  vertical-align: middle;
  &:hover {
    border: 1px solid ${props => props.theme.color.wfGrey300};
  }
`;

export const DateStyled = styled(Date)`
  display: inline-block;
  vertical-align: middle;
`;

export const ArrowIcon = styled(Icon)`
  margin-left: ${props => props.theme.spacing.xsmall};
`;

export const CTALink = styled(Link)`
  &:hover {
    text-decoration: underline;
  }
`;

export const ProjectInfoTerm = styled.div`
  padding: ${props =>
    `${props.theme.spacing.default} 0 ${props.theme.spacing.default} ${props.theme.spacing.medium}`};
  border-bottom: 1px solid ${props => props.theme.color.wfGrey200};
  font-weight: ${props => props.theme.font.weight.xbold};
  grid-column: 1;
`;
export const ProjectInfoDef = styled.div`
  padding: ${props =>
    `${props.theme.spacing.default} 0 ${props.theme.spacing.default} ${props.theme.spacing.medium}`};
  border-bottom: 1px solid ${props => props.theme.color.wfGrey200};

  margin-left: 0;
  grid-column: 2;
`;

export const ProjectInfoFullRow = styled.div`
  padding: ${props =>
    `${props.theme.spacing.default} 0 ${props.theme.spacing.default} ${props.theme.spacing.medium}`};
  border-bottom: 1px solid ${props => props.theme.color.wfGrey200};
  &:last-of-type {
    border-bottom: none;
  }
  font-weight: ${props => props.theme.font.weight.xbold};
  padding-bottom: 2em;
  padding-right: 2em;
  grid-column: 1 / span 2;
`;

export const ProjectInfo = styled.div`
  color: ${props => props.theme.color.wfBlack};
  margin-top: ${props => props.theme.spacing.medium};
  margin-left: -${props => props.theme.spacing.medium};
  margin-right: -${props => props.theme.spacing.medium};
  border-top: 1px solid ${props => props.theme.color.wfGrey200};
  display: grid;
  grid-template-columns: 1fr 1fr;
  border-right: none;
`;
